module.exports = __webpack_public_path__ + "static/img01-b4abc749822629c44e64d751e62e785d.png";